import * as React from "react"

function Cancel(props) {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 2l14 14M16 2L2 16"
        stroke="#6D7887"
        strokeWidth={1.5}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default Cancel
